/**
 * @file index.tsx
 *
 * @fileoverview Exports job application related enums.
 */

export enum JobApplicationWorkflowEnum {
  INTERNAL = 'inernal',
  EXTERNAL = 'external',
  NONE = 'none',
}
